import React, { useMemo } from 'react';
import { NotificationModalWithTip } from '@/components/topstep/notificationModal';
import { openInNewTab } from '@/helpers/urlHelper';
import CoachTip from '@/views/trader/components/notifications/CoachTip';
import { ActiveViolationModel, ViolationDuration, TradingRuleType, MarginScaleConfiguration, MarginScaleTime, ProfitSource } from '@/api/userApi';
import { Typography } from '@mui/material';

import { config } from '@/config';

interface MarginScaleRuleModalProps {
  violation: ActiveViolationModel;
  accountName: string;
  onHide: () => void;
}

const MarginScaleRuleModal: React.FC<MarginScaleRuleModalProps> = (props) => {
  return useMemo(() => {
    const violationTime = props.violation.triggeredAt.local().format('DD/MM/YYYY h:mm:ss A');
    var children = <div></div>;
    var header = '';

    if (props.violation.duration === ViolationDuration.Permanent) {
      header = 'Account ' + props.accountName + ': Ineligible for Funding';
      children = (
        <div>
          <p>
            Your account is now <b>ineligible for funding</b> due to violating the Margin Scale Rule. We have closed all open positions & working orders.
          </p>
          <p>Your open positions(s) was liquidated at (<strong>{violationTime}</strong>) for violating your account's Margin Scale Rule.</p>
        </div>
      );
    } else {
      header = 'Account ' + props.accountName + ': Temporarily Deactivated';
      children = (
        <div>
          <p>
            Your account has been <b>temporarily deactivated</b> for exceeding the Margin Scale at (<strong>{violationTime}</strong>).
          </p>
          <p>This blocks any further trading until the next trading day. Don't worry, you'll be able to resume trading at the start of the next day.</p>
        </div>
      );
    }

    return (
      <NotificationModalWithTip
        footer={<CoachTip />}
        header={header}
        onClickOutline={props.onHide}
        onClickBlue={() => openInNewTab('#')}
        buttonLabelOutline={'DISMISS THIS NOTIFICATION'}
        buttonLabelBlue={'VISIT DASHBOARD'}
        platform={config.platform}
      >
        {children}
      </NotificationModalWithTip>
    );
  }, [props.accountName, props.onHide]);
};

export default React.memo(MarginScaleRuleModal);
